import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../app/store/configureStore';
import { fetchKitchenStaffKitchenListAsync } from './kitchenStaffKitchenListSlice';
import Kitchen from '../../../app/data/models/kitchens/kitchen';
import FillWidthCell from '../../../app/components/FillWidthCell';
import StyledTableRow from '../../../app/components/StyledTableRow';
import { useTranslation } from 'react-i18next';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import ListTitleBox from '../../../app/components/list/ListTitleBox';
import EmptyScreen from '../../../app/components/EmptyScreen';

const KitchenStaffKitchenList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { restaurantId } = useParams<{ restaurantId: string }>();
  const { kitchens, status } = useAppSelector((state) => state.kitchens);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (restaurantId) dispatch(fetchKitchenStaffKitchenListAsync(restaurantId));
  }, [restaurantId, dispatch]);

  const handleKitchenClick = (kitchen: Kitchen) => {
    navigate(
      `/kitchen-staff/restaurants/${restaurantId}/kitchens/${kitchen.id}/orders?kitchenName=${kitchen.name}`
    );
  };

  if (status.includes('pending')) return <LoadingComponent />;

  if (!kitchens || kitchens.length === 0)
    return (
      <EmptyScreen
        title={t('kitchen.list.title')}
        emptyText={t('kitchen.list.empty')}
      />
    );

  return (
    <>
      <ListTitleBox title={t('kitchen.list.title')} />
      <TableContainer component={Paper} sx={{ width: '100%', mb: 2 }}>
        <Table
          sx={{
            minWidth: { xs: '100%', sm: 650 },
          }}
          aria-label={t('kitchen.list.title')}
        >
          <TableHead>
            <TableRow>
              <TableCell width="50px" align="left">
                #
              </TableCell>
              <FillWidthCell align="left">
                {t('kitchen.list.header.name')}
              </FillWidthCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {kitchens.map((kitchen, index) => (
              <StyledTableRow
                key={kitchen.id}
                onClick={() => handleKitchenClick(kitchen)}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                  width: '100%',
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'action.hover',
                  },
                }}
              >
                <TableCell width="50px" align="left" component="th" scope="row">
                  {index + 1}
                </TableCell>
                <TableCell align="left">{kitchen.name}</TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default KitchenStaffKitchenList;
